import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

export interface ButtonDetails {
  text: string;
  color: number;
  hasIcon?: boolean;
  icon?: string;
  customStyle?: string;
  type?: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-button-solid',
  templateUrl: './button-solid.component.html',
  styleUrls: ['./button-solid.component.scss'],
  standalone: true,
  imports: [NgClass],
})
export class ButtonSolidComponent {
  @Input() buttonDetails!: ButtonDetails;
  @Input() disabled = false;
}
